import { Expose } from "class-transformer";

export class CreateMetricDto {
  @Expose()
  name: string;

  @Expose()
  plural?: string;
}
